import { map, pickBy } from 'lodash';

import { FormQuestionTypeKeys } from 'screens/MissionControl/Utilities/NewFormBuilderPage/types';
import { questionTypesConfiguration } from 'screens/MissionControl/Utilities/NewFormBuilderPage/utils';
import { StaffReviewStatusEnum } from 'screens/PatientFormAnswersReviewScreen/interfaces/SyncFormPayload';

import { TYPE as MESSAGE_PARTIALS_SUB_TYPE } from './components/FilterMessagePartialsSubType/FilterMessagePartialsSubType.constants';
import { TYPE as MESSAGE_PARTIALS_TYPE } from './components/FilterMessagePartialsType/FilterMessagePartialsType.constants';

const availableQuestionTypeItems = map(
  pickBy(questionTypesConfiguration, 'isAvailableOnMenu'),
  (questionTypeItem, key) => ({
    label: questionTypeItem.label || 'Unknown',
    _id: key,
    key,
    ...(!!questionTypeItem.isCCDA && { isCCDA: 'true' }),
  }),
);

export const REFERRAL_STATUS = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'called,calledLate',
    label: 'Called',
  },
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
  {
    _id: 'expired',
    label: 'Expired',
  },
  {
    _id: 'incomplete',
    label: 'Incomplete',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'scheduled,scheduledLate',
    label: 'Scheduled',
  },
];

export const REFERRAL_STATUS_OUTBOUND = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'called',
    label: 'Called',
  },
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
  {
    _id: 'expired',
    label: 'Expired',
  },
  {
    _id: 'incomplete',
    label: 'Incomplete',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'scheduled',
    label: 'Scheduled',
  },
];

export const PATIENT_FORM_TEMPLATE_TYPE = [
  {
    _id: 'pre-qualification',
    label: 'Pre-scheduling',
  },
  {
    _id: 'intake',
    label: 'Intake',
  },
  {
    _id: 'feedback',
    label: 'Feedback',
  },
  {
    _id: 'ccda',
    label: 'CCDA',
  },
  {
    _id: 'scheduler-assist',
    label: 'Scheduler Assist',
  },
  {
    _id: 'queue-intake',
    label: 'Queue Intake',
  },
];

export const PATIENT_FORM_TEMPLATE_QUESTION_TYPE = [
  ...availableQuestionTypeItems,
  {
    _id: FormQuestionTypeKeys.twoFactor,
    key: FormQuestionTypeKeys.twoFactor,
    label: '2FA',
  },
];

export const PATIENT_FORM_TEMPLATE_JUMP_LOGIC = [
  {
    _id: 'question',
    label: 'Has Jump Logic to Question',
  },
  {
    _id: 'scheduler',
    label: 'Has Jump Logic to Scheduler',
  },
  {
    _id: 'url',
    label: 'Has Jump Logic to External URL',
  },
  {
    _id: 'false',
    label: 'No Jump Logic',
  },
];

export const PATIENT_FORM_TEMPLATE_REQUIRED_QUESTION = [
  {
    _id: 'true',
    label: 'Required',
  },
  {
    _id: 'false',
    label: 'Not Required',
  },
];

export const APPOINTMENT_STATUS = [
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'cancelled-noshow',
    label: 'No show',
  },
  {
    _id: 'confirmed',
    label: 'Confirmed',
  },
  {
    _id: 'confirmed-arrived',
    label: 'Arrived',
  },
  {
    _id: 'unconfirmed',
    label: 'Unconfirmed',
  },
];

export const STATUS_SOURCE = [
  {
    _id: 'luma',
    label: 'Luma Health',
  },
  {
    _id: 'integrator',
    label: 'Your EMR PM',
  },
];

export const APPOINTMENT_STATUS_REASON = [
  {
    _id: 'arrived',
    label: 'Arrived',
  },
  {
    _id: 'byOffer',
    label: 'By offer',
  },
  {
    _id: 'noshow',
    label: 'No Show',
  },
];

export const MODALITY = [
  {
    _id: 'office-visit',
    label: 'Office Visit',
  },
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
];

export const INSURANCE_VERIFICATION = [
  {
    _id: 'failed,inactive',
    label: 'Invalid insurance detected',
  },
  {
    _id: 'unknown',
    label: 'Insurance not checked yet',
  },
  {
    _id: 'active',
    label: 'At least one valid insurance',
  },
];

export const BILLING_STATUS = [
  {
    _id: 'notPaid',
    label: 'Not Paid',
  },
  {
    _id: 'paid',
    label: 'Paid',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'sent',
    label: 'Sent',
  },
  {
    _id: 'unknown',
    label: 'Unknown',
  },
];

export const ROLES = [
  {
    _id: 'admin',
    label: 'Admin',
  },
  {
    _id: 'manager',
    label: 'Manager',
  },
  {
    _id: 'subaccount,doctor',
    label: 'Sub Account',
  },
];

export const USER_STATUS = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'suspended',
    label: 'Suspended',
  },
];

export const FORM_PROCESSING_STATUS = [
  {
    _id: 'open',
    label: 'Open',
  },
  {
    _id: 'inProgress',
    label: 'In Progress',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
  {
    _id: 'scheduled',
    label: 'Scheduled',
  },
  {
    _id: 'noResponse',
    label: 'No Response',
  },
];

export const SENT_TO_EHR_STATUS = [
  {
    _id: 'success',
    label: 'Sent',
  },
  {
    _id: 'failure',
    label: 'Error',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'notApplicable',
    label: 'N/A',
  },
];

export const SENDING_TO_EHR = [
  {
    _id: 'true',
    label: 'Sending',
  },
  {
    _id: 'false',
    label: 'Disabled',
  },
];

export const PATIENT_FORM_STATUS = [
  {
    _id: 'true',
    label: 'Active',
  },
  {
    _id: 'false',
    label: 'Disabled',
  },
];

export const PATIENT_FORM_REVIEW_STATUS = [
  {
    _id: StaffReviewStatusEnum.Awaiting,
    label: 'Needs Review',
  },
  {
    _id: StaffReviewStatusEnum.Reviewing,
    label: 'In Review',
  },
  {
    _id: StaffReviewStatusEnum.Reviewed,
    label: 'Review Completed',
  },
];

export const FACILITY_FEATURES_ENABLED = [
  {
    _id: 'followup',
    label: 'Custom Action',
  },
  {
    _id: 'feedback',
    label: 'Feedback',
  },
  {
    _id: 'referral',
    label: 'Referral',
  },
  {
    _id: 'reminder',
    label: 'Reminder',
  },
  {
    _id: 'scheduler',
    label: 'Scheduler',
  },
  {
    _id: 'cancellation',
    label: 'Waitlist',
  },
];

export const PROVIDER_FEATURES_ENABLED = FACILITY_FEATURES_ENABLED.concat([
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
]);

export const APPTTYPE_FEATURES_ENABLED = FACILITY_FEATURES_ENABLED.concat([
  {
    _id: 'cancellation.autoAddToWaitlist',
    label: 'Waitlist Auto-Add',
  },
]);

export const INTEGRATION_FLAGS = [
  {
    _id: 'visible',
    label: 'Visible',
  },
  {
    _id: 'hidden',
    label: 'Hidden',
  },
];

export const PROVIDERS_INTEGRATION_FLAGS = [
  {
    _id: 'visible',
    label: 'Visible',
  },
  {
    _id: 'hidden',
    label: 'Hidden',
  },
  {
    _id: 'schedulable',
    label: 'Schedulable',
  },
  {
    _id: 'referring',
    label: 'Referring',
  },
  {
    _id: 'rendering',
    label: 'Rendering',
  },
];

export const REMINDER_TYPE = [
  {
    _id: 'appointment',
    label: 'Appointment',
  },
  {
    _id: 'feedback',
    label: 'Feedback',
  },
  {
    _id: 'followup',
    label: 'Follow-up',
  },
  {
    _id: 'outboundReferral',
    label: 'Outbound Referral',
  },
  {
    _id: 'patientForm',
    label: 'Patient Form',
  },
  {
    _id: 'referral',
    label: 'Referral',
  },
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
  {
    _id: 'waitingRoom',
    label: 'Waiting Room',
  },
];

export const USER_TYPE = [
  {
    _id: 'staff',
    label: 'Staff',
  },
  {
    _id: 'doctor',
    label: 'Provider',
  },
];

export const RECALL_STATUS = [
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'scheduled',
    label: 'Scheduled',
  },
];

export const CONSTANT_FILTERS: Record<string, Record<string, string>[]> = {
  referralStatus: REFERRAL_STATUS,
  referralStatusOutbound: REFERRAL_STATUS_OUTBOUND,
  apptStatus: APPOINTMENT_STATUS,
  patientFormType: PATIENT_FORM_TEMPLATE_TYPE,
  patientFormStatus: PATIENT_FORM_STATUS,
  formReviewStatus: PATIENT_FORM_REVIEW_STATUS,
  sendingToEHR: SENDING_TO_EHR,
  statusSource: STATUS_SOURCE,
  facilityAttributes: INTEGRATION_FLAGS,
  apptTypeAttributes: INTEGRATION_FLAGS,
  providerAttributes: PROVIDERS_INTEGRATION_FLAGS,
  providerFeatures: PROVIDER_FEATURES_ENABLED,
  facilityFeatures: FACILITY_FEATURES_ENABLED,
  apptTypeFeatures: APPTTYPE_FEATURES_ENABLED,
  roles: ROLES,
  userType: USER_TYPE,
  status: USER_STATUS,
  formProcessingStatus: FORM_PROCESSING_STATUS,
  sentToEhrStatus: SENT_TO_EHR_STATUS,
  modality: MODALITY,
  reminderType: REMINDER_TYPE,
  insuranceVerification: INSURANCE_VERIFICATION,
  billingTransactionStatus: BILLING_STATUS,
  recallStatus: RECALL_STATUS,
  messagePartialsType: MESSAGE_PARTIALS_TYPE,
  messagePartialsSubType: MESSAGE_PARTIALS_SUB_TYPE,
  questionType: PATIENT_FORM_TEMPLATE_QUESTION_TYPE,
  requiredQuestion: PATIENT_FORM_TEMPLATE_REQUIRED_QUESTION,
  jumpLogic: PATIENT_FORM_TEMPLATE_JUMP_LOGIC,
};
